<template>
    <div class="study-book">
        <studySearch @searchClick='searchClick' @advancedSearch='advancedSearch' :sourceType="'studyBook'"></studySearch>
        <div class="book-cont">
            <div class="cont-top">
                <div class="top-pic">
                    <img width="100%" :src="bookInfo.coverPath" alt="">
                </div>
                <div class="top-txt">{{bookInfo.introduction}}</div>
            </div>
            <div class="catalogue">目录</div>
            <div class="book-list">
                <!-- 一级目录 -->
                <div class="level-one" v-for="(item, index) in catalogueTree" :key="'l1-' + index">
                    <div class="level-one-title" @click="toggleExpand(index, item)">
                        <!-- class="el-icon-caret-right expand-icon"  -->
                        <i v-if="item.children && item.children.length > 0"  
                           :class="{ 'is-expanded': expandedItems.includes(index) }">
                        </i>
                        <!-- <i v-else class="el-icon-tickets"></i> -->
                        {{ item.label }}
                    </div>
                    <!-- 二级目录 -->
                    <div class="level-two-wrap" v-if="item.children && item.children.length > 0" v-show="expandedItems.includes(index)">
                        <div class="level-two" v-for="(child, cIndex) in item.children" :key="'l2-' + cIndex">
                            <div class="level-two-title" @click="handleClick(child)">
                                 <!-- class="el-icon-caret-right expand-icon"  -->
                                <i v-if="child.children && child.children.length > 0" 
                                   :class="{ 'is-expanded': child.expanded }">
                                </i>
                                {{ child.label }}
                            </div>
                            <!-- 三级目录（网格布局） -->
                            <ul class="level-three-grid" v-if="child.children && child.children.length > 0" v-show="child.expanded">
                                <li 
                                    class="level-three-item" 
                                    v-for="(grandChild, gIndex) in child.children" 
                                    :key="'l3-' + gIndex"
                                    @click="handleClick(grandChild)"
                                >
                                    {{ grandChild.label }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <deductScore ref="deduct_score" v-if="isShowTip" :show.sync="isShowTip" :sourceType="'book'"></deductScore>

    </div>
</template>

<script> 
import studySearch from './comps/study_search.vue' 
import { bookInfo,bookCatalogTree } from '../../io/api'
import deductScore from './comps/study_deduct_score.vue'
import { mapState } from 'vuex'
export default {
    components: {
        studySearch,
        deductScore,
    },
    data () {
        return {
            bookId:this.$route.query.id||'',
            bookInfo:{},
            catalogueTree:[],
            expandedItems: [], // 记录展开的一级目录索引
            isShowTip:false,
        }
    },
    computed: {
        ...mapState({
            searchVal: state => state.study.searchVal,
        }),
    },
    mounted(){
        this.getList();
    },
    methods: {
        searchClick(){
            
        },
        getList(){
            this.getBookInfo();
            this.getCatalogTree();
        },
        // 获取古籍信息
        getBookInfo(){
            bookInfo({id:this.bookId}).then(res => {
                let {code,data,msg}=res.data;
                if(code==0){
                    this.bookInfo=data||{};
                }else{
                    this.$message.error(msg||'获取古籍信息失败');
                }
            })
        },
        // 获取古籍目录树
        getCatalogTree(){
            let params={
                dataId:this.bookId,
                type:1,
            }
            bookCatalogTree(params).then(res => {
                let {code,data,msg}=res.data;
                if(code==0){
                    this.catalogueTree=data.catalogList||[];
                }else{
                    this.$message.error(msg||'获取古籍目录树失败');
                }
            })
        },
        advancedSearch(){
            
        },
        toggleExpand(index, item){
            // 如果有子目录，则切换展开/收起状态
            if(item.children && item.children.length > 0){
                const idx = this.expandedItems.indexOf(index);
                if(idx > -1){
                    // 收起：移除索引并收起所有子目录
                    this.expandedItems.splice(idx, 1);
                    this.setChildrenExpanded(item, false);
                } else {
                    // 展开：添加索引并展开所有子目录
                    this.expandedItems.push(index);
                    this.setChildrenExpanded(item, true);
                }
            } else {
                // 没有子目录，直接跳转详情
                this.toDetail(item);
            }
        },
        // 递归设置所有子目录的展开状态
        setChildrenExpanded(item, expanded){
            if(item.children && item.children.length > 0){
                item.children.forEach(child => {
                    this.$set(child, 'expanded', expanded);
                    this.setChildrenExpanded(child, expanded);
                });
            }
        },
        handleClick(item){
            // 如果有子目录，则切换展开/收起状态
            if(item.children && item.children.length > 0){
                this.$set(item, 'expanded', !item.expanded);
            } else {
                // 没有子目录，直接跳转详情
                this.toDetail(item);
            }
        },
        toDetail(item){ 
            console.log(item,)
            this.isShowTip=true; 
            this.$nextTick(()=>{ 
                this.$refs.deduct_score.get_studyCheckScoreStatus(item,this.searchVal)
            })

            // let url=this.$router.resolve({
			// 	path:'/bookDetails',  
			// 	query:{ 
            //         treeId: item.dataId,
			// 	}
			// })
            // window.open(url.href, '_blank') 
        }
    }

}
</script>

<style lang="less" scoped>
.study-book{
    min-width: 1200px;
    margin-bottom: 40px;
    .book-cont{
        width: 1200px;
        margin: 40px auto;
        padding:30px;
        box-shadow: 0px 3px 12px 0px #c4bfbc;
        .cont-top{
            display: flex;
            justify-content: space-between;
            padding-bottom: 20px;
            border-bottom: 1px solid #386DE8;
            .top-pic{
                width: 260px;
                height: 310px;
                /* border-radius: 20px; */
                padding: 12px;
                overflow: hidden;
            }
            .top-txt {
                width: 800px; 
                margin: 0 auto;
                line-height: 40px;
            }
        }
        .catalogue{
            font-size: 22px;
            font-weight: bold;
            margin: 20px 0;
            padding-left: 16px;
            border-left: 6px solid #386DE8;
            color: #000;
            
        }
        .book-list{
            background: #F1F5FE; 
            
            .level-one{
                .level-one-title{
                    cursor: pointer;
                    font-size: 18px;
                    // font-weight: bold;
                    color: #333;
                    height: 40px;
                    line-height: 40px;
                    padding-left: 20px;
                    display: flex;
                    align-items: center;
                    .expand-icon{
                        margin-right: 8px;
                        transition: transform 0.3s;
                        font-size: 14px;
                        &.is-expanded{
                            transform: rotate(90deg);
                        }
                    }
                    .el-icon-tickets{
                        margin-right: 8px;
                        font-size: 14px;
                        // color: #386DE8;
                    }
                    &:hover{
                        color: #386DE8;
                        background: #e8f0fe;
                    }
                }
                
                .level-two-wrap{
                    padding:0 28px;
                    
                    .level-two{
                        .level-two-title{
                            cursor: pointer;
                            font-size: 16px;
                            font-weight: bold;
                            color: #333;
                            height: 40px;
                            line-height: 40px;
                            padding-left: 10px;
                            display: flex;
                            align-items: center;
                            .expand-icon{
                                margin-right: 8px;
                                transition: transform 0.3s;
                                &.is-expanded{
                                    transform: rotate(90deg);
                                }
                            }
                            &:hover{
                                color: #386DE8;
                                background: #e8f0fe;
                            }
                        }
                        
                        .level-three-grid{
                            display: flex;
                            flex-wrap: wrap;
                            padding-left: 20px;
                            
                            .level-three-item{
                                cursor: pointer;
                                width: 33.33%;
                                box-sizing: border-box;
                                padding: 0 10px;
                                height: 40px;
                                line-height: 40px;
                                font-size: 14px;
                                color: #333;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                &:hover{
                                    color: #386DE8;
                                    background: #e8f0fe;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

</style>